import { LargeTitleWithText } from '@gofranz/common-components';
import { Container } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IntegrationsCategoryList } from '../components/Integrations';
import { Footer } from '../components/Layout/Footer';

export function IntegrationsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Container size="lg" py="xl">
        <LargeTitleWithText
          title={t('integrations.cards.pageTitle')}
          text={t('integrations.cards.pageDescription')}
          mb="xxl"
        />
        <IntegrationsCategoryList />
      </Container>

      <Footer />
    </>
  );
}
